import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      width: '90%',
      margin: '0 auto',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    boxForm: {
      display: 'grid',
      gridGap: 63,
      width: '50%'
    },
    leftForm: {
      display: 'grid',
      gridRowGap: 24,
      '& label': {
        color: theme.custom.colors.primary,
      }
    },
    desc: {
      font: theme.custom.font.paragraph,
    },
    dropdown: {
      flex: 1,
    },
  };
});

export default useStyles;
